import ManagementRegimesOverview from './ManagementRegimesOverview'

export default ManagementRegimesOverview
